import './styles.scss'

import type { JSX } from 'react'

import { ReorderIcon } from '@/components/Icons'

interface AddToCartButtonProps {
  className?: string
  style?: React.CSSProperties
  handleClick: () => void
}

export default function AddToCartButton({
  className,
  style,
  handleClick,
}: AddToCartButtonProps): JSX.Element {
  return (
    <button
      className={`add-to-cart-btn__container ${className}`}
      style={style}
      type="button"
      onClick={handleClick}
    >
      {/* <img alt="Add to Cart" src={ReorderIcon} /> */}
      <ReorderIcon />
    </button>
  )
}
